import React, { useEffect, useState } from "react";
import { Modal, List, Typography, Divider, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { post } from "../services/services";
import { ApiURL } from "../services/apiConstants";

const NotificationModal = ({ isModalOpen, setIsModalOpen, handleUnreadCountChange }) => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchNotifications = async () => {
    const FORM_DATA = new FormData();
    try {
      const res = await post(ApiURL?.bell_icon_notifiction_list, FORM_DATA);
      if (res?.status === true) {
        const filteredData = res.data || [];
        setNotifications(filteredData);
        handleUnreadCountChange(filteredData.filter((n) => !n.read_status).length);
      } else {
        console.error("Error: API response was not successful", res);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle Notification Click
  const handleNotificationClick = async (notification) => {

    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", notification.id);
    try {
      const res = await post(ApiURL.bell_icon_notifiction_list, FORM_DATA);
      if (res?.status === true) {
        fetchNotifications();
      } else {
        console.error("Error: API response was not successful", res);
      }
    } catch (error) {
      console.error("Error updating notification:", error);
    }

    // Navigate based on notification type
    const { type } = notification;
    if (type === "logbook") {
      navigate("/logbook");
    } else if (type === "staff") {
      navigate("/staff/details");
    } else {
      // localStorage.setItem("selectedKey", "19");
      navigate("/notification");
    }
    // Close the modal
    setIsModalOpen(false);
  };

  // Use useEffect with Staff_id to trigger fetching notifications once it is set
  useEffect(() => {
    fetchNotifications();
  }, []); // This effect will only run when Staff_id changes

  return (
    <Modal
      title="Notifications"
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      style={{
        position: "fixed",
        top: "60px",
        right: "220px",
        borderRadius: "8px",
        zIndex: 9999,
      }}
    >
      {loading ? (
        <Spin size="large" />
      ) : notifications.length === 0 ? (
        <Typography.Text
          type="secondary"
          style={{ display: "block", textAlign: "center", padding: "20px" }}
        >
          No notifications
        </Typography.Text>
      ) : (
        <div style={{ maxHeight: "400px", overflowY: "auto", paddingRight: "4px" }}>
          <List
            itemLayout="horizontal"
            dataSource={notifications}
            renderItem={(notification) => {
              const isRead = notification?.read_status;
              return (
                <List.Item
                  key={notification?.id}
                  style={{
                    backgroundColor: isRead ? "#f9f9f9" : "#e6f7ff",
                    padding: "12px 16px",
                    borderRadius: 8,
                    marginBottom: 8,
                    cursor: "pointer",
                    boxShadow: isRead ? "none" : "0 2px 8px rgba(24, 144, 255, 0.15)",
                    transition: "background-color 0.3s ease",
                  }}
                  onClick={() => handleNotificationClick(notification)}
                >
                  <List.Item.Meta
                    title={
                      <Typography.Text strong={!isRead}>
                        {notification?.description || "No message"}
                      </Typography.Text>
                    }
                    description={`Received at ${new Date(
                      notification?.created_at
                    ).toLocaleString()}`}
                  />
                </List.Item>
              );
            }}
          />
        </div>
      )}
      <Divider />
    </Modal>
  );
};

export default NotificationModal;
